import React, { useEffect, useState } from 'react';
import '../LoadingScreen.css';

const LoadingScreen = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [phaseIndex, setPhaseIndex] = useState(0);

  const phrases = [
    'Conectando histórias',
    'Reunindo impactos',
    'Transformando vidas',
    'Espalhando esperança',
  ];

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.height = '100%';

    const duration = 3200;
    const steps = 80;
    const increment = 100 / steps;
    let currentProgress = 0;

    const interval = setInterval(() => {
      currentProgress += increment;
      if (currentProgress >= 100) {
        currentProgress = 100;
        clearInterval(interval);
        setTimeout(() => {
          document.body.style.overflow = '';
          document.body.style.position = '';
          document.body.style.width = '';
          document.body.style.height = '';
          if (onComplete) onComplete();
        }, 500);
      }
      setProgress(Math.floor(currentProgress));
    }, duration / steps);

    const phraseInterval = setInterval(() => {
      setPhaseIndex((p) => (p + 1) % phrases.length);
    }, 850);

    return () => {
      clearInterval(interval);
      clearInterval(phraseInterval);
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
    };
  }, [onComplete]);

  return (
    <div className="vi-loading" data-testid="loading-screen">
      {/* Soft pastel light aurora */}
      <div className="vi-aurora" aria-hidden="true">
        <span className="vi-aurora__blob vi-aurora__blob--peach" />
        <span className="vi-aurora__blob vi-aurora__blob--mint" />
        <span className="vi-aurora__blob vi-aurora__blob--gold" />
        <span className="vi-aurora__blob vi-aurora__blob--blush" />
      </div>

      {/* Decorative soft grid */}
      <div className="vi-grid" aria-hidden="true" />

      {/* Floating hearts/sparkles */}
      <div className="vi-sparkles" aria-hidden="true">
        {Array.from({ length: 12 }).map((_, i) => (
          <span key={i} className={`vi-sparkle vi-sparkle--${i + 1}`} />
        ))}
      </div>

      <div className="vi-loading__container">
        {/* Top label */}
        <div className="vi-loading__eyebrow">
          <span className="vi-eyebrow-line" />
          <span>Responsabilidade Social</span>
          <span className="vi-eyebrow-line" />
        </div>

        {/* Stage with rings + logo */}
        <div className="vi-loading__stage">
          {/* Concentric pulsating rings */}
          <div className="vi-rings" aria-hidden="true">
            <span className="vi-rings__layer vi-rings__layer--1" />
            <span className="vi-rings__layer vi-rings__layer--2" />
            <span className="vi-rings__layer vi-rings__layer--3" />
          </div>

          {/* Orbiting dots */}
          <div className="vi-orbit vi-orbit--1" aria-hidden="true">
            <span className="vi-orbit__dot" />
          </div>
          <div className="vi-orbit vi-orbit--2" aria-hidden="true">
            <span className="vi-orbit__dot" />
          </div>
          <div className="vi-orbit vi-orbit--3" aria-hidden="true">
            <span className="vi-orbit__dot" />
          </div>

          {/* Impact ripples */}
          <div className="vi-ripple" aria-hidden="true">
            <span className="vi-ripple__ring" />
            <span className="vi-ripple__ring" />
            <span className="vi-ripple__ring" />
          </div>

          {/* Center orb with logo */}
          <div className="vi-orb">
            <div className="vi-orb__halo" />
            <div className="vi-orb__inner">
              <img
                src="/images/vimpact-logo-nobg.png"
                alt="Viva Impact"
                className="vi-orb__logo"
                onError={(e) => { e.currentTarget.style.display = 'none'; }}
              />
            </div>
          </div>
        </div>

        {/* Brand */}
        <div className="vi-loading__brand">
          <h1 className="vi-loading__title">
            <span className="vi-loading__title-text">VIVA</span>
            <span className="vi-loading__title-accent">IMPACT</span>
          </h1>
          <div className="vi-loading__phrases" aria-live="polite">
            {phrases.map((p, i) => (
              <span
                key={i}
                className={`vi-loading__phrase ${i === phaseIndex ? 'is-active' : ''}`}
              >
                {p}
              </span>
            ))}
          </div>
        </div>

        {/* Progress meter */}
        <div className="vi-loading__meter">
          <div className="vi-loading__track">
            <div className="vi-loading__fill" style={{ width: `${progress}%` }}>
              <span className="vi-loading__fill-glow" />
            </div>
          </div>
          <div className="vi-loading__meta">
            <div className="vi-loading__count">
              <span className="vi-loading__count-number">{String(progress).padStart(3, '0')}</span>
              <span className="vi-loading__count-percent">%</span>
            </div>
            <div className="vi-loading__status">
              <span className="vi-status-pulse" />
              Preparando experiência
            </div>
          </div>
        </div>

        {/* Signature */}
        <div className="vi-loading__signature">
          <span className="vi-dot" />
          <span>Parceria Viva Impact</span>
          <span className="vi-amp">&amp;</span>
          <span>WG</span>
          <span className="vi-dot" />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
